// src/modules/app-views/_apps/appmulti/receivables/seed.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import appService from 'services/appService';
import { logErrorSilent } from 'utils/errorLogger';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const DEFAULT_SEEDS = {
  form: {},
  requiredFields: ['entityId', 'value', 'dueDate', 'billingType'],
};

// *******************************************************************************
// MAIN FUNCTION
// *******************************************************************************
async function seedReceivablesParameters({ moduleId, storedParameters }) {
  if (!moduleId) return;

  const moduleParams = storedParameters?.modules?.[moduleId];
  if (moduleParams && Object.keys(moduleParams).length > 0) {
    return [];
  }

  const results = [];

  const formResult = await seedForm({ moduleId, defaultData: DEFAULT_SEEDS.form });
  if (formResult) results.push(formResult);

  const requiredFieldsResult = await seedRequiredFields({
    moduleId,
    defaultData: DEFAULT_SEEDS.requiredFields,
  });
  if (requiredFieldsResult) results.push(requiredFieldsResult);

  return results;
}

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default seedReceivablesParameters;

// *******************************************************************************
// HELPERS
// *******************************************************************************
async function seedForm({ moduleId, defaultData }) {
  try {
    await appService.updateModulePreferences({ category: 'form', moduleId, data: defaultData });
    return { category: 'form', seeded: true, data: defaultData };
  } catch (error) {
    logErrorSilent(error, { context: 'seedReceivablesParameters:seedForm' });
    return { category: 'form', seeded: false, error };
  }
}

async function seedRequiredFields({ moduleId, defaultData }) {
  try {
    await appService.updateModulePreferences({
      category: 'requiredFields',
      moduleId,
      data: defaultData,
    });
    return { category: 'requiredFields', seeded: true, data: defaultData };
  } catch (error) {
    logErrorSilent(error, { context: 'seedReceivablesParameters:seedRequiredFields' });
    return { category: 'requiredFields', seeded: false, error };
  }
}
